import React, { useEffect, useState, lazy, Suspense } from 'react';
import './HomePage.scss';
import { Dialog, DialogTitle } from '@material-ui/core';

export default function HomePage(props) {
    const [openDialog, setOpenDialog] = useState(false);
    const HomePageEnrolSection = lazy(() => import('../../components/homepage/homepage-enrol/HomePageEnrolSection'));
    const HomePageCoursesSection = lazy(() => import('../../components/homepage/homepage-courses/HomePageCoursesSection'));
    const HomePageCourseSection = lazy(() => import('../../components/homepage/homepage-course/HomePageCourseSection'));
    const HomePageFaqSection = lazy(() => import('../../components/homepage/homepage-faq/HomePageFaqSection'));

    useEffect(() => {
        window.scrollTo(0, 0);
        setOpenDialog(true);

        setTimeout(() => {
            var video = document.getElementById("homepage-video");
            if (video) {
                video.play();
            }
        }, 1000);

        setTimeout(() => {
            var video = document.getElementById("homepage-video");
            if (video) {
                video.play();
            }
        }, 3000)
    }, []);

    function closeDialog() {
        setOpenDialog(false);
    }

    return (
        <div className="homepage-section-wrapper">
            <Suspense fallback={<div></div>}>
                <HomePageEnrolSection></HomePageEnrolSection>
                <HomePageCoursesSection></HomePageCoursesSection>
                <HomePageCourseSection></HomePageCourseSection>
                <HomePageFaqSection></HomePageFaqSection>

                <Dialog className="homepage-splash" open={openDialog}>
                    <div className="homepage-splash-wrapper">
                        <div className="homepage-splash-video">
                            <div className="homepage-splash-text">Available in English, Chinese, Malay and Tamil!</div>
                            <div className="faq-wrapper-item-text" dangerouslySetInnerHTML={{ __html: '<video id="homepage-video" width="100%" autobuffer autoplay loop muted playsinline><source src="/assets/videos/EOP Promotional available language 02032020.mp4" type="video/mp4" />Your browser does not support the video tag. </video>' }}></div>
                        </div>
                        <button className="blue-btn" onClick={closeDialog}>Okay</button>
                    </div>
                </Dialog>
            </Suspense>
        </div>
    )
}